import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCookies } from 'react-cookie';
import VideoFilesFullLoop from './VideoFilesFullLoop';
import useGame from '../hooks/useGame';
import { trackPageView } from '../helpers/gaHelper';

// import Title
import { ReactComponent as TitleET } from '../assets/img/title_est_kyberkatse.svg';
import { ReactComponent as TitleLT } from '../assets/img/title_lit_pinkles.svg';
import { ReactComponent as TitleLV } from '../assets/img/title_lat_kiberkvests.svg';
import KeyVideo_ET_ET from '../assets/video/key_videos/et-et.mp4';
import KeyVideo_ET_RU from '../assets/video/key_videos/et-ru.mp4';
import KeyVideo_LT_LT from '../assets/video/key_videos/lt-lt.mp4';
import KeyVideo_LV_LV from '../assets/video/key_videos/lv-lv.mp4';
import KeyVideo_LV_RU from '../assets/video/key_videos/lv-ru.mp4';


const Intro = () => {
  const { PUBLIC_URL, REACT_APP_LANGUAGE } = process.env;
  const { t } = useTranslation();
  const { nextQuestion, toggleAudioState, isPlayingBackgroundMusic, setTrackUser, initializeGTM, trackUser, language, showSoundLayer } = useGame();

  useEffect(() => {
    trackPageView('/');
  }, []);

  const [cookies, setCookie] = useCookies();
  const [showPolicy, setShowPolicy] = useState(true);
  const [policyUrl, setPolicyUrl] = useState('');


  useEffect(() => {
    const suffix = `${PUBLIC_URL}/pdf/cookies_policy_`;

    if(REACT_APP_LANGUAGE === 'et' && language === 'et'){
      setPolicyUrl(`${suffix}et_et.pdf`);
    }
    if(REACT_APP_LANGUAGE === 'et' && language === 'ru'){
      setPolicyUrl(`${suffix}et_ru.pdf`);
    }
    if(REACT_APP_LANGUAGE === 'lt' && language === 'lt'){
      setPolicyUrl(`${suffix}lt_lt.pdf`);
    }
    if(REACT_APP_LANGUAGE === 'lv' && language === 'lv'){
      setPolicyUrl(`${suffix}lv_lv.pdf`);
    }
    if(REACT_APP_LANGUAGE === 'lv' && language === 'ru'){
      setPolicyUrl(`${suffix}lv_ru.pdf`);
    }
  }, [REACT_APP_LANGUAGE, language]);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = `${PUBLIC_URL}/assets/js/main.js`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // attach the jquery.nicescroll.min.js file
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `${PUBLIC_URL}/assets/js/jquery.nicescroll.min.js`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (cookies['seb_consent']) {
      setShowPolicy(false);
      setTrackUser(cookies['seb_consent'] === 'accept');
    }
  }, []);

  useEffect(() => {
    initializeGTM();
  }, [trackUser]);

  const setCookieValue = (value) => {
    setCookie('seb_consent', value);
    setTrackUser(value === 'accept');
    setShowPolicy(false);
  };


  return (
    <main className="intro">

      <section className="start">
        <div id="loader" />
      </section>

      <section className="scroll">
        <div className="scrollmagic-container" id="scrollContainer">

          <VideoFilesFullLoop page='intro' id='intro-video' />

          <div className="sound layer">

            <div className="inner">

              {!isPlayingBackgroundMusic && (
                <span tabIndex={0} id="sound-top-intro" role='button'
                  onClick={(evt) => toggleAudioState(evt, 'sound-top-intro')} 
                  onKeyDown={(evt) => toggleAudioState(evt, 'sound-top-intro')} 
                  className="icon sound-mute sound-intro" />
              )}
              {isPlayingBackgroundMusic && (
                <span tabIndex={0} id="sound-top-intro" role='button'
                  onClick={(evt) => toggleAudioState(evt, 'sound-top-intro')} 
                  onKeyDown={(evt) => toggleAudioState(evt, 'sound-top-intro')} 
                  className="icon sound sound-intro" />
              )}

              <p>{t('intro.sound_needed')}</p>
              <div role='button' tabIndex={0} id="skip-intro" className="skip-intro"><span className="current-time" id="sec" /><span
                className="txt">{t('intro.skip_video')}</span></div>

            </div>

          </div>

          <div role='button' tabIndex={0} className="skip-intro rply">{t('intro.skip_video')}</div>

          <div className="text-container" id="txt-container">

            <div className="top-cover" />

            <div className="text-wrap">

              {REACT_APP_LANGUAGE === 'et' && (<TitleET />)}
              {REACT_APP_LANGUAGE === 'lt' && (<TitleLT />)}
              {REACT_APP_LANGUAGE === 'lv' && (<TitleLV />)}

              <div className="overlay" id="overlay" />

            </div>

            <div className="bottom-cover" />

          </div>

          <div className="layer ready">
            <h1>{t('intro.play')}</h1>
            <button tabIndex={0} className="default" id="start-button" onClick={(evt) => nextQuestion(evt)}>{t('intro.ready')}</button>
            <div role='button' tabIndex={0} id="replay-intro">{t('intro.replay_video')}</div>
            <div className="start-mob" id="start-btn-mob">
              <span className="icon finger-print" onClick={nextQuestion} />
              <span className="text">{t('intro.tap_to_start')}</span>
            </div>
          </div>

          <span 
            role='button'
            tabIndex={0} 
            className="icon mouse"
            onClick={(evt) =>showSoundLayer(evt)} 
            onKeyDown={(evt) =>showSoundLayer(evt)}
          />
          <span 
            role="presentation"
            className="icon mouse-mob" 
          />

        </div>
      </section>

      {showPolicy && (
      <div className="cookie-notice reveal">
        <span style={{ display: 'none' }} className="icon close-helper" 
          onClick={() => setShowPolicy(false)}
          onKeyDown={(evt) => {
            if (evt?.keyCode === 13 || evt?.keyCode === 32) {
              return setShowPolicy(false)
            }
          }}
        />
        <p>{t('cookie.text')} <strong><a href={policyUrl} target="_blank" rel="noopener noreferrer">{t('cookie.url')}</a></strong>.</p>
        {(REACT_APP_LANGUAGE === 'lv' && language === 'lv' && (<><br /><p>{t('cookie.extra_text')}</p></>))}
        <div className="button-wrap">
          <button className="default agree" onClick={() => setCookieValue('accept')}>{t('cookie.agree')}</button>
          <button className="default not-agree" onClick={() => setCookieValue('decline')}>{t('cookie.disagree')}</button>
        </div>
      </div>
      )}

    </main>
  );
};

export default Intro;
